import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

const tagOptions = ['全部', '反转盘点', '录音流出', '聊天记录', '当事人回应', '打脸现场', '证据梳理'];

export default function FeedAndCats() {
  const [tag, setTag] = useState('全部');
  const list = useMemo(
    () => (tag === '全部' ? articles : articles.filter((a) => a.tag === tag)),
    [tag],
  );

  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        {/* category showcase */}
        <div className="mb-8 flex items-end justify-between gap-4">
          <div>
            <h3 className="text-xl md:text-2xl font-bold">按圈吃瓜</h3>
            <p className="mt-1 text-sm text-foreground-600">四大栏目，哪里热闹往哪看</p>
          </div>
          <Link to="/category/quannei" className="hidden items-center whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700 sm:inline-flex">
            全部栏目 <i className="ri-arrow-right-line ml-1" aria-hidden="true" />
          </Link>
        </div>
        <div className="mb-10 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {categories.map((c) => {
            const count = articles.filter((a) => a.cat === c.slug).length;
            return (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="group rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 transition hover:-translate-y-1"
              >
                <span className={`mb-3 flex h-11 w-11 items-center justify-center rounded-md text-xl ${c.tint}`}>
                  <i className={c.icon} aria-hidden="true" />
                </span>
                <h4 className="text-base font-bold text-foreground-950 group-hover:text-primary-700">{c.name}</h4>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{c.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-foreground-400 group-hover:text-primary-600">
                  {count} 篇瓜讯 <i className="ri-arrow-right-line transition group-hover:translate-x-0.5" aria-hidden="true" />
                </span>
              </Link>
            );
          })}
        </div>

        {/* feed with filter */}
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h3 className="text-xl md:text-2xl font-bold">最新瓜讯</h3>
            <p className="mt-1 text-sm text-foreground-600">事件真相、当事人回应与证据梳理，一次看个够</p>
          </div>
          <div className="flex flex-wrap gap-2">
            {tagOptions.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setTag(t)}
                className={`whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium transition ${
                  tag === t
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 hover:text-primary-700 border border-background-200'
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>
      </div>
    </section>
  );
}